import styled, {css} from "styled-components";
import {VOUCHER_CARD_WIDTH} from "../../voucher-card-css-constants";

export const VoucherCardBox = styled.div<{showCursor: boolean; }>`
    position: relative;

    width: ${VOUCHER_CARD_WIDTH};
    height: 170px;
    margin: 0 auto 26px;
    ${props => props.showCursor ? css`cursor: pointer` : ''};
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        width: 240px;
        height: 145px;
    }
`;
